var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_vm._t("trigger"),_c('div',{staticClass:"tooltipContent"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }